import { styled } from '@linaria/react';

import { fonts, semantic, size, space } from '../../theme/tokens';

export const Group = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-300']};
`;

export const OptionLabel = styled.label`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-400']};
  min-height: 76px;
  padding: ${space['space-400']} ${space['space-600']};
  border: 1px solid ${semantic.border.default};
  border-radius: ${size.radius['radius-sm']};
  background: ${semantic.bg.canvas};
  cursor: pointer;
  transition: border-color 0.15s ease;

  &[data-selected='true'] {
    border-color: ${semantic.border.selected};
  }

  &[data-disabled='true'] {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-100']};
`;

export const OptionLabelText = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.md};
  font-weight: ${fonts.weight.medium};
  color: ${semantic.text.primary};
`;

export const OptionDescription = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.xs};
  color: ${semantic.text.secondary};
`;

export const RadioInput = styled.input`
  appearance: none;
  margin: 0;
  width: 18px;
  height: 18px;
  border: 1px solid ${semantic.border.default};
  border-radius: 50%;
  cursor: inherit;
  background: ${semantic.bg.canvas};
  position: relative;
  flex-shrink: 0;

  &:checked {
    border-color: ${semantic.border.selected};
    background: ${semantic.border.selected};
    box-shadow: inset 0 0 0 3px ${semantic.text.inverse};
  }

  &:disabled {
    cursor: not-allowed;
  }
`;
